import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import { Colors } from "src/assets/colors/Colors";
import InputForm from "src/components/ComponentesFormularios/InputForm";
import { GlobalConstants } from "src/data/GlobalConstants";
import { modalCRUDService } from "src/services/modalCRUDService";
import FilterTable from "src/components/FilterTable";
import ExternalActionsTable from "src/components/ExternalActionsTable";
import AgGridTable from "src/components/AgGridTable";
import ExcelToJSON from "src/components/ExcelToJSON";
import { alertQuestionService } from "src/services/alertQuestionService";
import { gruposImpulsarService } from "src/services/unoauno/apiGruposImpulsar";
import { generalService } from "src/services/unoauno/apiGeneral";

const COLUMN_DEF = [
    {headerName: '', field: "select", resizable: true, sortable: true, filter: true, minWidth: 70, headerCheckboxSelection: true, checkboxSelection: true},
    {headerName: "ID de Producto", field: "idProducto", minWidth: 100, resizable: true, sortable: false, filter: false},
    {headerName: "Nombre de Producto", field: "nombreProducto", minWidth: 232, resizable: true, sortable: false, filter: false}
];

const CustomExternalActions = ({dispatch, reload, idGrupo, setProductosDisponibles, setProductosGrupo, productosGrupo}) => {
    const [file, setFile] = useState(null)

    const onUploadExcelProductos = async (datos, file) => {
        try {
            const xlsxDescripcion = new File ([file], "Productos a impulsar")
            setFile(xlsxDescripcion)

            const res = await gruposImpulsarService.validarExcelProductos(datos[0].data)

            if(res.data.error.length > 0){
                alertQuestionService.showAlert({
                    title: `Ha ocurrido un error al realizar el cargue`, question: ``,
                    message: `No se encontraron los siguientes productos: `,
                    html: 
                    <div className="customScroll" style={{width: "100%", display: "flex", justifyContent: "center", marginTop: "20px", fontSize: "11pt", maxHeight: "48vh", overflow: "auto"}}>
                        <table className="tableError">
                            <thead>
                                <tr>
                                    <th>Fila</th>
                                    <th>Codigo de Producto</th>
                                </tr>
                            </thead>
                            <tbody>
                                {res.data.error.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{item.row}</td>
                                            <td>{item.idProducto}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>,
            
                    actionBtnAceptar: () => alertQuestionService.clear(),
                    type: GlobalConstants.alertInfo,
                    size: 'sm'
                })

            }else {
                setProductosDisponibles(prev => prev.filter(pro => !res.data.dataValidate.some(pro2 => pro2.idProducto == pro.idProducto)))
                setProductosGrupo(prev => [...prev, ...res.data.dataValidate])
                setProductosGrupo(prev => prev.filter((pro, index, self) => index == self.findIndex((t) => (t.idProducto == pro.idProducto))))
            }
        } catch (error) {
            console.log(error);
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Excel inválido' } });
        }
    }

    const onSaveProductos = async () => {
        alertQuestionService.showAlert({
            title: `Asignar Productos`, question: ``,
            message: `¿Estás seguro de asignar estos productos al grupo?`,
    
            actionBtnAceptar: async () => {
                alertQuestionService.clear();
                try {
                    await gruposImpulsarService.saveProductosGrupo({ idGrupo, productos: productosGrupo })
                    
                    if(file && productosGrupo.length > 0) await generalService.saveExcel({ file })

                    reload()
                    modalCRUDService.clear();
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: 'Solicitud exitosa' } });
                } catch (error) {
                    console.log(error);
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Ha ocurrido un error, comunicate con soporte' } })
                }
            },
            actionBtnCancelar: () => alertQuestionService.clear(),
            type: GlobalConstants.alertInfo,
            size: 'sm'
        })
    }

    return (
        <div className="d-flex align-items-center">
            <ExcelToJSON
                identificador="cargueProductos" 
                handleChange={(datos, file) => onUploadExcelProductos(datos, file)}
                titleTooltip="Cargue masivo"
                color={Colors.COLOR_GREEN_DARK}
            />

            <Tooltip className="m-0 ml-3 mr-1" title="Guardar Cambios" aria-label="saveChanges">
                <a onClick={() => onSaveProductos()} className="icon-container-actions d-flex">
                    <div style={{backgroundColor: Colors.GREEN_SWITCH_ACTIVE}}/>
                    <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save"/>
                </a>
            </Tooltip>
        </div>
    )
}

const TableGruposProductos = ({ properties }) => {
    const { data: { idProveedor, idGrupo, nombre, productos, productosImpulsarDisponibles, reload } } = properties;
    const dispatch = useDispatch();

    const [productosGrupo, setProductosGrupo] = useState(productos);
    const [productosDisponibles, setProductosDisponibles] = useState(productosImpulsarDisponibles);
    const [valueSearch, setValueSearch] = useState("");

    const tableRefDisponibles = useRef(null);
    const tableRefActuales = useRef(null);

    const searchProductos = async (value) => {
        setValueSearch(value);

        try {
            const res = await gruposImpulsarService.getProductosImpulsarDisponibles({ search: value, idProveedor });
            const productosFiltrados = res.data.filter(pro => !productosGrupo.some(proG => (proG.idProducto == pro.idProducto))) ?? [];
            setProductosDisponibles(productosFiltrados);
        } catch (error) {
            console.log(error)
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Ha ocurrido un error, comunicate con soporte' } })
        }
    }

    const addProductos = () => {
        const selectedRows = tableRefDisponibles.current.api.getSelectedRows();
        const productosActuales = [...productosGrupo, ...selectedRows.filter(pro => !productosGrupo.some(proG => (proG.idProducto == pro.idProducto)))];
        const productosDisponiblesFiltrados = productosDisponibles.filter(pro => !selectedRows.some(proG => (proG.idProducto == pro.idProducto)));

        setProductosGrupo(productosActuales);
        setProductosDisponibles(productosDisponiblesFiltrados);
    }

    const removeProductos = () => {
        const selectedRows = tableRefActuales.current.api.getSelectedRows();
        const productosDisponiblesFiltrados = [...productosDisponibles, ...selectedRows];
        const productosActuales = productosGrupo.filter(pro => !selectedRows.some(proG => (proG.idProducto == pro.idProducto)));

        setProductosGrupo(productosActuales);
        setProductosDisponibles(productosDisponiblesFiltrados);
    }

    return (
        <div className="w-100 row m-0 p-0" style={{height: "75vh"}}>
            <div className="col px-2">
                <span className="ml-2" style={{fontSize: "12pt", fontWeight: "bold"}}>Productos disponibles:</span>
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center w-50" style={{marginTop: "-10px"}}>
                        <InputForm
                            identificador="searchFilterProductosDisponibles"
                            value={valueSearch}
                            label=""
                            placeholder="Buscar..."
                            className="w-100 mx-2"
                            handleChange={({name, value}) => searchProductos(value)}
                        />
                    </div>
                </div>
                <div className="mx-2">
                    <AgGridTable
                        referencia={tableRefDisponibles}
                        columnDef={COLUMN_DEF}
                        height="64vh"
                        defaultColDef={{wrapHeaderText: true, autoHeaderHeight: true}}
                        dataList={productosDisponibles}
                        rowSelection={'multiple'}
                        onGridReady={params => params.api.sizeColumnsToFit()}
                    />
                </div>
            </div>
            
            <div className="h-100 d-flex align-items-center justify-content-center" style={{width: "5vw"}}>
                <div className="w-100 d-flex flex-column align-items-center justify-content-center" style={{gap: "15px"}}>
                    <Tooltip className="m-0" title="Agregar productos" aria-label="agregarProductos">
                        <a onClick={() => addProductos()} className="icon-container-actions d-flex">
                            <div style={{backgroundColor: Colors.GREEN_SWITCH_ACTIVE}}/>
                            <i style={{color: Colors.GREEN_SWITCH_ACTIVE}} className="fas fa-arrow-right"/>
                        </a>
                    </Tooltip>

                    <Tooltip className="m-0" title="Remover productos" aria-label="removerProductos">
                        <a onClick={() => removeProductos()} className="icon-container-actions d-flex">
                            <div style={{backgroundColor: Colors.ROJO_PASTEL}}/>
                            <i style={{color: Colors.ROJO_PASTEL}} className="fas fa-arrow-left"/>
                        </a>
                    </Tooltip>
                </div>
            </div>

            <div className="col px-2">
                <span className="ml-2" style={{fontSize: "12pt", fontWeight: "bold"}}>Productos en el grupo:</span>
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center w-50" style={{marginTop: "-10px"}}>
                        <FilterTable tableRef={tableRefActuales} identificador="searchFilterProductos" className="w-100 mx-2" />
                    </div>

                    <ExternalActionsTable
                        customActions={ <CustomExternalActions 
                            dispatch={dispatch}
                            reload={reload}
                            idGrupo={idGrupo}
                            setProductosDisponibles={setProductosDisponibles}
                            setProductosGrupo={setProductosGrupo}
                            productosGrupo={productosGrupo}
                        />}
                        accionExcel={{
                            tableRef: tableRefActuales,
                            fileName: `Productos a impulsar - ${nombre}`,
                            sheetName: "Productos a impulsar",
                            structure: [
                                { fieldOld: "idProducto", fieldNew: "Codigo de producto" },
                                { fieldOld: "nombreProducto", fieldNew: "Nombre de producto" }
                            ]
                        }}
                    />
                </div>
                <div className="mx-2">
                    <AgGridTable
                        referencia={tableRefActuales}
                        columnDef={COLUMN_DEF}
                        height="64vh"
                        defaultColDef={{wrapHeaderText: true, autoHeaderHeight: true}}
                        dataList={productosGrupo}
                        rowSelection={'multiple'}
                        onGridReady={params => params.api.sizeColumnsToFit()}
                    />
                </div>
            </div>
        </div>
    )
}

export default TableGruposProductos;